import DOMPurify from "dompurify";

const TERMS_ALLOWED_TAGS = [
  "a",
  "b",
  "blockquote",
  "br",
  "code",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "i",
  "li",
  "ol",
  "p",
  "pre",
  "strong",
  "style",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul",
];

const TERMS_ALLOWED_ATTR = ["class", "href", "rel", "target"];

export const sanitizeHtml = (html: string) => {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    FORCE_BODY: true,
    ALLOWED_TAGS: TERMS_ALLOWED_TAGS,
    ALLOWED_ATTR: TERMS_ALLOWED_ATTR,
    ADD_URI_SAFE_ATTR: ["rel", "target"],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|\/(?!\/)|#)/i,
  });

  const template = document.createElement("template");

  template.innerHTML = sanitizedHtml;
  template.content.querySelectorAll("a[target]").forEach((link) => {
    if (link.getAttribute("target")?.toLowerCase() !== "_blank") {
      link.removeAttribute("target");
      return;
    }

    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  return template.innerHTML;
};
